export default __webpack_public_path__ + "static/media/local_small_lamp_grass.ae11c17b.png";